var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_799",
    "data-name": "Group 799",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    width: 40,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M35,0H5A5,5,0,0,0,0,5V25a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5",
    fill: "#27337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M19.661,11.164c-.017,1.451,1.252,2.261,2.21,2.743.984.494,1.314.81,1.31,1.252-.008.675-.785.974-1.511.985a5.13,5.13,0,0,1-2.594-.636l-.456,2.208a7.375,7.375,0,0,0,2.807.535c2.651,0,4.386-1.351,4.4-3.446.01-2.659-3.564-2.806-3.539-4,.009-.36.341-.745,1.071-.842a4.628,4.628,0,0,1,2.49.45l.444-2.135a6.577,6.577,0,0,0-2.363-.448c-2.5,0-4.252,1.369-4.266,3.33M30.555,8.018a1.152,1.152,0,0,0-1.075.739l-3.788,9.338h2.65l.527-1.5h3.237l.306,1.5H34.75L32.711,8.018Zm.37,2.721.765,3.784H29.6ZM16.449,8.018l-2.09,10.076h2.526L18.972,8.018Zm-3.736,0-2.629,6.858L9.021,9.044A1.189,1.189,0,0,0,7.856,8.018H3.56L3.5,8.31a10.288,10.288,0,0,1,2.491.858,1.1,1.1,0,0,1,.6.885L8.6,18.094h2.669L15.364,8.018Z",
    transform: "translate(0.875 1.958)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.24a57968de100b619fe78f28b7361422.svg";
export { ForwardRef as ReactComponent };